import { render, staticRenderFns } from "./Legend.vue?vue&type=template&id=57bb7c45&scoped=true"
import script from "./Legend.vue?vue&type=script&lang=js"
export * from "./Legend.vue?vue&type=script&lang=js"
import style0 from "./Legend.vue?vue&type=style&index=0&id=57bb7c45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bb7c45",
  null
  
)

export default component.exports